import { BIModel } from './BIModel';

export class GenericClickBIModel extends BIModel {

  static eventName = 'click';

  #action;

  constructor(userId, action) {
    super(GenericClickBIModel.eventName, userId);
    this.#action = action;
  }

  get action() {
    return this.#action;
  }

  get modelData() {
    return {
      action: this.action
    };
  }

}